import { createFileRoute } from '@tanstack/react-router';

import { BloodReportLayout } from '@/pages/blood-report/layout';

export const Route = createFileRoute('/blood-report/_role-guard/$id/_report')({
  component: BloodReportLayout,
});
